import React from 'react'
import { injectIntl } from 'react-intl'
import GoalReportIcon from 'assets/img/report-event-icon.svg'
import { withLocation } from 'redux/enhancers'
import classnames from 'classnames'
import style from './style.module.scss'

const GoalReportSnippet = ({ data, intl: { formatMessage }, redirectTo, unread, notificationId, referenceId }) => {
  if (!data)
    return null

  const redirect = () => redirectTo(`/goal-report?goalId=${referenceId}&notificationId=${notificationId}`)

  if (data.goalByQualification) {
    return (
      <div
        className={classnames(style.goalReportSnippet, { [style.unread]: unread })}
        onClick={redirect}
        role="button"
        onKeyPress={redirect}
        tabIndex={0}
      >
        <img src={GoalReportIcon} alt="" />
        <div className={style.info}>
          {formatMessage({ id: 'notifications.notification.goal-report.income.title' })}
          <br />
          {formatMessage({ id: 'notifications.notification.goal-report.income.description' })}
        </div>
      </div>
    )
  }

  if (data.goalByIncome) {
    return (
      <div
        className={classnames(style.goalReportSnippet, { [style.unread]: unread })}
        onClick={redirect}
        role="button"
        onKeyPress={redirect}
        tabIndex={0}
      >
        <img src={GoalReportIcon} alt="" />
        <div className={style.info}>
          {formatMessage({ id: 'notifications.notification.goal-report.qualification.title' })}
          <br />
          {formatMessage({ id: 'notifications.notification.goal-report.qualification.description' })}
        </div>
      </div>
    )
  }

  return null
}

export default withLocation(injectIntl(GoalReportSnippet))
